import React from "react";
import { TextField, FormGroup } from "@material-ui/core/";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

import { withStyles } from "@material-ui/core/styles";
import { FormStyles } from "../../../../styles";

const Identification = props => {
  const { t } = useTranslation();

  return (
    <div>
      <FormGroup>
        <TextField
          label={t("signup.labels.identifiant")}
          name={`compteRequestDto[identifiant]`}
          variant="outlined"
          onChange={props.handleChange}
          onBlur={props.handleBlur}
          helperText={
            <span className={props.classes.formError}>
              {props.touched.compteRequestDto &&
                props.touched.compteRequestDto["identifiant"] &&
                props.errors.compteRequestDto &&
                props.errors.compteRequestDto["identifiant"]}
            </span>
          }
          value={props.values.compteRequestDto.identifiant}
        />
      </FormGroup>
      <FormGroup>
        <TextField
          label={t("signup.labels.password")}
          name={`compteRequestDto[motDePasse]`}
          variant="outlined"
          type="password"
          onChange={props.handleChange}
          onBlur={props.handleBlur}
          helperText={
            <span className={props.classes.formError}>
              {props.touched.compteRequestDto &&
                props.touched.compteRequestDto["motDePasse"] &&
                props.errors.compteRequestDto &&
                props.errors.compteRequestDto["motDePasse"]}
            </span>
          }
          value={props.values.compteRequestDto.motDePasse}
        />
      </FormGroup>
      <FormGroup>
        <TextField
          label={t("signup.labels.confirm_password")}
          name={`compteRequestDto[comfirmerMotDePasse]`}
          variant="outlined"
          type="password"
          onChange={props.handleChange}
          onBlur={props.handleBlur}
          helperText={
            <span className={props.classes.formError}>
              {props.touched.compteRequestDto &&
                props.touched.compteRequestDto["comfirmerMotDePasse"] &&
                props.errors.compteRequestDto &&
                props.errors.compteRequestDto["comfirmerMotDePasse"]}
            </span>
          }
          value={props.values.compteRequestDto.comfirmerMotDePasse}
        />
      </FormGroup>
    </div>
  );
};

Identification.propTypes = {
  touched: PropTypes.object,
  values: PropTypes.object,
  errors: PropTypes.object,
  handleBlur: PropTypes.func,
  handleChange: PropTypes.func
};

export default withStyles(FormStyles)(Identification);
